import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowSplitUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowSplitUp"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H10V5H6.41421L12 10.5858L17.5858 5H14V3H21V10H19V6.41421L13 12.4142V21H11V12.4142L5 6.41421V10H3V3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowSplitUp;
